import React from 'react';
export function HeroSection() {
  return <header className="pt-12 pb-8" data-id="element-185">
      {/* Masthead */}
      <div className="text-center mb-8 border-b border-[#1a1a1a] pb-4" data-id="element-186">
        <div className="text-[12px] tracking-[0.2em] font-sans font-bold text-[#1a1a1a] uppercase mb-1" data-id="element-187">
          Wellness Daily
        </div>
        <div className="text-[10px] font-sans text-[#666] uppercase tracking-wider" data-id="element-188">
          Independent Health & Mobility Reviews
        </div>
      </div>

      {/* Article Header */}
      <div className="mb-8" data-id="element-189">
        <div className="flex items-center gap-2 mb-4" data-id="element-190">
          <span className="text-[10px] font-bold text-[#8B2500] uppercase tracking-wider font-sans bg-[#8B2500]/5 px-2 py-1 rounded-sm" data-id="element-191">
            Mobility · Joint Health
          </span>
          <span className="text-[10px] text-[#888] font-sans uppercase tracking-wider" data-id="element-192">
            · 8 min read
          </span>
        </div>

        <h1 className="text-[32px] md:text-[40px] leading-[1.15] font-bold text-[#1a1a1a] mb-6 font-serif" data-id="element-193">
          The 15-Day Method That's Helping Thousands Walk Without Fear Again
        </h1>

        <div className="flex items-center justify-between border-t border-b border-[#E5E5E0] py-3 mb-8" data-id="element-194">
          <div className="flex items-center gap-3" data-id="element-195">
            <div className="w-8 h-8 rounded-full bg-[#E5E5E0] flex items-center justify-center text-[#8B2500] font-serif font-bold text-xs" data-id="element-196">
              SM
            </div>
            <div className="flex flex-col" data-id="element-197">
              <span className="text-[11px] font-bold text-[#1a1a1a] font-sans uppercase tracking-wide" data-id="element-198">
                By Ryan Carter
              </span>
              <span className="text-[10px] text-[#666] font-sans" data-id="element-199">
                Movement Specialist · Published February 5, 2026
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Image */}
      <figure className="mb-10" data-id="element-200">
        <div className="w-full bg-[#F5F5F0] p-8 rounded-sm mb-3 border border-[#E5E5E0]" data-id="element-201">
          <img src="https://cdn.magicpatterns.com/uploads/dhFEgYBjJoWDrrEjUjNWsZ/mock_up_english.png" alt="The Knee Geometry Method digital guide displayed on a tablet" className="w-full h-auto object-contain max-h-[400px] mix-blend-multiply" data-id="element-202" />
        </div>
        <figcaption className="text-[11px] text-[#666] font-sans text-center italic" data-id="element-203">
          The Knee Geometry Method digital guide has been downloaded over 2,400
          times since launch.
        </figcaption>
      </figure>
    </header>;
}